import PDFGlobal from '@/views/report/App'

export default {
    path: 'global-pdf',
    component: PDFGlobal,
    name: 'PdfGlobal'
  }